<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Log In</h4>
                  <p class="mb-0">Enter your username and password to log in</p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="signin">
                    <div class="mb-3">
                      <argon-input v-model="username" type="text" placeholder="Username" name="email" size="lg" isRequired autofocus/>
                    </div>
                    <div class="mb-3">
                      <argon-input v-model="password" type="password" placeholder="Password" name="password" size="lg" isRequired/>
                    </div>
                    <argon-switch id="rememberMe">Remember me</argon-switch>

                    <div class="text-center">
                      <button type="submit" :class="'mt-4 btn btn-primary full-width w-100 ' + (loading ? 'disabled' : '')">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Sign In
                      </button>
                      <argon-alert v-if="error_message" color="danger" icon="fa fa-exclamation-triangle">
                        {{error_message}}
                      </argon-alert> 
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://images.unsplash.com/photo-1572883454114-1cf0031ede2a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxhbGx8fHx8fHx8fHwxNjE4Njk2NTk5&ixlib=rb-1.2.1&q=80&w=1080&utm_source=unsplash_source&utm_medium=referral&utm_campaign=api-credit');
          background-size: cover;"
              >
                <span class="mask bg-gradient-primary opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >"Attention is the new currency"</h4>
                <p
                  class="text-white position-relative"
                >The more effortless the writing looks, the more effort the writer actually put into the process.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
const body = document.getElementsByTagName("body")[0];
const endpoint = require('../router/endpoint')

export default {
  name: "signin",
  data() {
    return {
      username: null,
      password: null,
      loading: false,
      error_message: null,
    }
  },
  components: {
    // Navbar,
    ArgonInput,
    ArgonSwitch,
    ArgonAlert,
  },
  methods: {
    signin() {
      this.loading = true
      this.error_message = false
      this.axios.post(endpoint.SIGN_IN, {
        username: this.username,
        password: this.password
      })
        .then(response => {
          if (response.data.response_code === '0000') {
            this.$store.dispatch('setLoginState', true)
            localStorage.setItem('isLogin', true)
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('name', response.data.data.partner_name)
            localStorage.setItem('partner_id', response.data.data.partner_id)
            localStorage.setItem('partner_user_id', response.data.data.partner_user_id)
            localStorage.setItem('partner_user_name', response.data.data.partner_user_name)
            localStorage.setItem('partner_code', response.data.data.partner_code)
            localStorage.setItem('partner_vat', response.data.data.partner_vat)
            localStorage.setItem('menu', JSON.stringify(response.data.data.access_menu))

            this.$router.replace('/')
          }
          else {
            this.$notify({
              type: 'warn',
              title: 'Warning!',
              text: response.data.message
            });
            this.loading = false
          }
        })
        .catch(e => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
          });
          this.loading = false
        })
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
